import React from "react";
import { View } from "react-native";
import OpenURLButton from "../common/OpenUrlButton";
import { styles } from "./styles/LoginFooter.styles";
import { labelText, urls } from "../../resources/strings";
import { theme } from "../../theme/theme";
import { isQRVisible } from "@lib/utilities/Constants";

const LoginFooter = () => {
  return (
    <View
      style={[
        styles.termsPolicy,
        {
          backgroundColor: isQRVisible()
            ? "transparent"
            : theme.colors.qrBackground,
        },
      ]}
    >
      <OpenURLButton url={urls.privacyURL}>
        {labelText.login.privacy}
      </OpenURLButton>
      <OpenURLButton url={urls.termsURL}>{labelText.login.terms}</OpenURLButton>
    </View>
  );
};

export default LoginFooter;
